import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { X } from "lucide-react";

export default function Banner({ position = "top" }) {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState({});

  useEffect(() => {
    api.get("/banners").then((r) => setBanners(r.data || [])).catch(() => {});
  }, []);

  const visible = banners.filter((b) => b.position === position && !dismissed[b.id]);
  if (!visible.length) return null;

  return (
    <div className="space-y-3" data-testid={`banner-${position}`}>
      {visible.map((b) => (
        <a key={b.id} href={b.link_url || "#"} target={b.link_url ? "_blank" : undefined} rel="noreferrer"
          data-testid={`banner-item-${b.id}`}
          className="block relative brutal-border brutal-shadow-sm rounded-xl overflow-hidden brutal-hoverable"
          style={{ background: "var(--accent)" }}>
          <div className="flex items-center gap-4 p-3">
            {b.image_url && (
              <img src={b.image_url} alt={b.title}
                className="w-20 h-20 object-cover brutal-border rounded-lg"
                onError={(e) => { e.target.style.display = "none"; }} />
            )}
            <div className="flex-1">
              <div className="text-xs uppercase tracking-widest font-bold text-zinc-700">Sponsored</div>
              <div className="font-display font-black text-lg leading-tight">{b.title}</div>
            </div>
          </div>
          <button onClick={(e) => { e.preventDefault(); setDismissed({ ...dismissed, [b.id]: true }); }}
            className="absolute top-2 right-2 w-7 h-7 grid place-items-center brutal-border rounded-full bg-white"
            data-testid={`banner-dismiss-${b.id}`}>
            <X size={14} />
          </button>
        </a>
      ))}
    </div>
  );
}
